import { render, staticRenderFns } from "./campDetail.vue?vue&type=template&id=1c4c2ca6&scoped=true"
import script from "./campDetail.vue?vue&type=script&lang=js"
export * from "./campDetail.vue?vue&type=script&lang=js"
import style0 from "./campDetail.vue?vue&type=style&index=0&id=1c4c2ca6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4c2ca6",
  null
  
)

export default component.exports